// components
import { styled, Box, BoxProps } from '@mui/material';

export const StyledTextFieldContainer = styled(Box)<BoxProps>(({ theme }) => ({
  marginBottom: theme.spacing(4)
}));
